/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { authControllerLogin } from '../fn/auth/auth-controller-login';
import { AuthControllerLogin$Params } from '../fn/auth/auth-controller-login';
import { authControllerLoginLegacyToken } from '../fn/auth/auth-controller-login-legacy-token';
import { AuthControllerLoginLegacyToken$Params } from '../fn/auth/auth-controller-login-legacy-token';
import { authControllerMe } from '../fn/auth/auth-controller-me';
import { AuthControllerMe$Params } from '../fn/auth/auth-controller-me';
import { authControllerRegister } from '../fn/auth/auth-controller-register';
import { AuthControllerRegister$Params } from '../fn/auth/auth-controller-register';
import { AuthResponseDto } from '../models/auth-response-dto';
import { Boolean } from '../models/boolean';

@Injectable({ providedIn: 'root' })
export class AuthApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authControllerLogin()` */
  static readonly AuthControllerLoginPath = '/api/auth/login';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerLogin$Response(params: AuthControllerLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseDto>> {
    const obs = authControllerLogin(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerLogin(params: AuthControllerLogin$Params, context?: HttpContext): Observable<AuthResponseDto> {
    const resp = this.authControllerLogin$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AuthResponseDto>): AuthResponseDto => r.body)
    );
  }

  /** Path part for operation `authControllerLoginLegacyToken()` */
  static readonly AuthControllerLoginLegacyTokenPath = '/api/auth/login-legacy-token';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerLoginLegacyToken()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerLoginLegacyToken$Response(params: AuthControllerLoginLegacyToken$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseDto>> {
    const obs = authControllerLoginLegacyToken(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerLoginLegacyToken$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  authControllerLoginLegacyToken(params: AuthControllerLoginLegacyToken$Params, context?: HttpContext): Observable<AuthResponseDto> {
    const resp = this.authControllerLoginLegacyToken$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AuthResponseDto>): AuthResponseDto => r.body)
    );
  }

  /** Path part for operation `authControllerRegister()` */
  static readonly AuthControllerRegisterPath = '/api/auth/demonstrateur/register';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerRegister()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerRegister$Response(params?: AuthControllerRegister$Params, context?: HttpContext): Observable<StrictHttpResponse<Boolean>> {
    const obs = authControllerRegister(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerRegister$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerRegister(params?: AuthControllerRegister$Params, context?: HttpContext): Observable<Boolean> {
    const resp = this.authControllerRegister$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Boolean>): Boolean => r.body)
    );
  }

  /** Path part for operation `authControllerMe()` */
  static readonly AuthControllerMePath = '/api/auth/me';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authControllerMe()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerMe$Response(params?: AuthControllerMe$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseDto>> {
    const obs = authControllerMe(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authControllerMe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authControllerMe(params?: AuthControllerMe$Params, context?: HttpContext): Observable<AuthResponseDto> {
    const resp = this.authControllerMe$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AuthResponseDto>): AuthResponseDto => r.body)
    );
  }

}
